// node modules
import React, { FC, useCallback } from 'react';
// ui-library
import {
  CloseOutlineIcon,
  CommunityIcon,
  View,
  Text,
  useThemeDetector,
} from '@upstox/upstox-ui';
// modules
import { useStore } from 'modules/Stores';
import LocaleService from 'modules/Localization';
import AppService from 'modules/App/service';
import Routing from 'modules/Routing';
import AnalyticsService from 'modules/Analytics';
// constants
import { EVENTS } from 'modules/Analytics/consts';
// styles
import * as css from './styles';

const ReleaseNotesHeader: FC = () => {
  const { theme, toggleModal } = useStore('AppStore');
  const autoTheme = useThemeDetector();
  const currentTheme = theme === 'auto' ? autoTheme : theme;
  const isDarkTheme = currentTheme === 'dark';

  const handleClose = useCallback(() => {
    toggleModal('releaseNotes');
  }, [toggleModal]);

  const handleCommunity = useCallback(() => {
    Routing.openNewUrl(AppService.config.releaseNotes.communityUrl);
    AnalyticsService.sendEvent(EVENTS.COMMUNITY_ICON_CLICKED, {
      Source: 'What\'s New',
    }, true);
  }, []);

  return (
    <View
      css={css.header}
      justifyContent="space-between"
      alignItems="center"
      alignSelf="stretch"
    >
      <View flexDirection="column" gap="xxsmall">
        <View>
          <Text css={css.subText} cssProps={{ isDarkTheme }}>
            {LocaleService.translate('RELEASE_NOTES')}
          </Text>
        </View>
        <View>
          <Text css={css.titleText} cssProps={{ isDarkTheme }}>
            {LocaleService.translate('WHATS_NEW')}
          </Text>
        </View>
      </View>
      <View gap="xxsmall">
        <View
          css={css.icon}
          cssProps={{ isDarkTheme }}
          alignItems="center"
          justifyContent="center"
          onClick={handleCommunity}
        >
          <CommunityIcon size="large" />
        </View>
        <View
          css={css.icon}
          cssProps={{ isDarkTheme }}
          alignItems="center"
          justifyContent="center"
          onClick={handleClose}
        >
          <CloseOutlineIcon size="large" />
        </View>
      </View>
    </View>
  );
};

export default ReleaseNotesHeader;
